import React, { Component } from "react";
import { graphql } from "gatsby";
import Layout from 'layout';
import siteConfig from 'data/SiteConfig';
import { FacebookShareButton } from 'react-share';
import { Helmet } from "react-helmet";


const moment = require("moment")

class post extends Component {
	render() {
		const { directusArticleList } = this.props.data;
		const date_format = moment(directusArticleList.date_created).format(siteConfig.dateFromFormat);
		return (
			<Layout>
				<Helmet>
					<title>{directusArticleList.title} - {siteConfig.siteTitle}</title>
					<meta property="og:url" content={this.props.location.href} />
					<meta property="og:type" content="article" />
					<meta property="og:title" content={directusArticleList.title + ' - ' + siteConfig.siteTitle} />
					<meta property="og:description" content={directusArticleList.short_description} />
					<meta property="og:image" content={directusArticleList.poster_link} />
				</Helmet>
				<div id="post">
					<div className="article-container">
						<div className="article-container__title">
							{directusArticleList.title}
						</div>
						<div className="article-container__date">
							{date_format}
						</div>
						<div className="article-container__poster">
							<img className="img-fluid" src={directusArticleList.poster_link} alt="" />
						</div>
						<div
							className="article-container__content"
							dangerouslySetInnerHTML={{ __html: directusArticleList.content }}
						/>
						<FacebookShareButton
							url={this.props.location.href}
							className="container__share"
						>
							<img src={require("assets/img/News/Button_Share-Berita.png")} alt="" />
						</FacebookShareButton>
					</div>
				</div>
			</Layout>
		);
	}
}

export default post;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
	query PostQuery($id: Int!)
	{
		directusArticleList(
			directusId: {
				eq: $id
			}
		) {
			short_description
			directusId
			title
			content
			slug
			poster_link
		}
	}
`;
